var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFees = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4363 0.0664062H55.5999V29.9664H10.4363V0.0664062ZM33.0181 7.54141C35.0144 7.54141 36.929 8.32895 38.3407 9.73078C39.7523 11.1326 40.5454 13.0339 40.5454 15.0164C40.5454 16.9989 39.7523 18.9002 38.3407 20.302C36.929 21.7039 35.0144 22.4914 33.0181 22.4914C31.0217 22.4914 29.1071 21.7039 27.6955 20.302C26.2839 18.9002 25.4908 16.9989 25.4908 15.0164C25.4908 13.0339 26.2839 11.1326 27.6955 9.73078C29.1071 8.32895 31.0217 7.54141 33.0181 7.54141ZM20.4726 5.04974C20.4726 6.3714 19.9439 7.63893 19.0028 8.57349C18.0617 9.50804 16.7854 10.0331 15.4544 10.0331V19.9997C16.7854 19.9997 18.0617 20.5248 19.0028 21.4593C19.9439 22.3939 20.4726 23.6614 20.4726 24.9831H45.5635C45.5635 23.6614 46.0922 22.3939 47.0333 21.4593C47.9744 20.5248 49.2508 19.9997 50.5817 19.9997V10.0331C49.2508 10.0331 47.9744 9.50804 47.0333 8.57349C46.0922 7.63893 45.5635 6.3714 45.5635 5.04974H20.4726ZM0.399902 10.0331H5.41808V34.9497H45.5635V39.9331H0.399902V10.0331Z",
    fill: "#F26722"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFees);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fees.d6be8ee546bde61d358dd3e632252a95.svg";